<template>
  <div class="tishabeav-amounts">
    <div class="styled-radio styled-radio--ou-donation row">
      <div v-for="amount of amounts" :key="amount" class="radio-part" :data-amount="amount">
          <input :id="`amount${amount}`" type="radio" class="amount" @click="selectedAmount = amount" :checked="selectedAmount == amount">
          <FormLabel :for="`amount${amount}`" :data-amount="amount">
          <MoneyFormat class="label-amount" :value="amount" :currencyCode="form.currency || 'USD'" :hide-subunits="subunits" />
        </FormLabel>
      </div>

      <div class="amount_other__wrapper" v-if="includeOther" :class="form.currency">
          <input id="amount_other_check" type="radio" class="amount" name="amount" value="Other">
          <input id="amount_other_field" type="number" min="1" name="amount_other" :placeholder="amountText" v-model="customAmount" />
      </div>
    </div>
    <div class="sponsorship-selector">
      <label class="control-label" for="sponsorSelect">Select to Sponsor a livestream </label>
      <select id="sponsorSelect" v-model="sponsorSelect" @change="emitValue($event); ">
        <option data-key="Weinreb" value="Weinreb">
          $5,000 - Rabbi Dr. Tzvi Hersh Weinreb's livestream
        </option>
        <option data-key="Weil" value="Weil">
          $5,000 - Rabbi Steven Weil's livestream
        </option>
        <option data-key="Glasser" value="Glasser">
          $5,000 - Rabbi Yaakov Glasser's livestream
        </option>
        <option data-key="Womens" value="Womens">
          $5,000 - OU Women’s Initiative Holding on to Faith
        </option>
      </select>
    </div>
  </div>
</template>
<script lang="ts">
import {
  computed,
  defineComponent,
  type PropType,
  ref,
  watch,
} from 'vue'
import { usePaymentForm } from '~/shared/use-payment-form'

import { queryParams } from '~/shared/query-params'

export default defineComponent({  props: {
    subunits: {
      type: Boolean,
      default: true
    },
    includeOther: {
      type: Boolean,
      default: true
    },
    defaultCheckedAount:{
      type: String
    },
    amountText:{
      type: String,
      default: "Amount",
    }
  },
  setup(props) {
    const { setValue, form, settings } = usePaymentForm()

    const selectedAmount = ref()
    const sponsorSelect = ref()
    const customAmount = ref(form.value.amount)

    watch(selectedAmount, (selectedAmount) => {
      if (selectedAmount) {
        customAmount.value = null
        sponsorSelect.value = null
        setValue("custom.selectedDescription", null);

        setValue('amount', '' + selectedAmount)
      }
    })

    watch(customAmount, (customAmount) => {
      if (customAmount) selectedAmount.value = null
      setValue("custom.selectedDescription", null);

      if (!selectedAmount.value) setValue('amount', customAmount || null)
    })

    function emitValue(e: any) {
        customAmount.value = null
        selectedAmount.value = null
        setValue("custom.selectedDescription", sponsorSelect.value);
        setValue("amount", '5000');
    };

    const amounts = computed(() => {
      const amounts = settings!.amounts!

      if (Array.isArray(amounts)) {
        return amounts
      }

      return amounts[form.value.currency || 'USD']
    })

    const params = queryParams()

    if (params.amount) {
      //@ts-ignore
      if (amounts.value.includes(+params.amount)) {
        selectedAmount.value = params.amount
      }
      else {
        customAmount.value = params.amount
      }
    }

    if (props.defaultCheckedAount) {
      //@ts-ignore
      if (amounts.value.includes(+props.defaultCheckedAount)) {
        selectedAmount.value = props.defaultCheckedAount
      }
      else {
        customAmount.value = props.defaultCheckedAount
      }
    }

    return {
      form,
      amounts,
      sponsorSelect,
      emitValue,
      selectedAmount,
      customAmount,
    }
  },
})
</script>
<style scoped lang="scss">
.oudonate-other-amount .amount_other__wrapper,
.styled-radio--ou-donation  .amount_other__wrapper{
    position: relative;
    margin-bottom: 10px;
    margin-right: 0;
    min-width: 16.6%;
    max-width: 31.6%;
    overflow: hidden;
    border: 1px solid #ddd;
    border-radius: 4px;
    padding-left: 5px;
    flex: 1;
    line-height: 1;
    @media (max-width: 720px) {
      margin-right: 5px;
      margin-left: 5px;
      margin-bottom: 10px;
    }
    &:before {
      content: '$';
      position: absolute;
      padding: 15px 8px;
      border-right: 1px solid #ddd;
      height: 100%;
      background: #fff;
      top: 0px;
      left: 0;
    }
    &.USD:before {content: '$'}
    &.CAN:before {content: 'C$'}
    &.ILS:before {content: '₪'}

    input[type='number'] {
      border: none;
      margin-left: 20px;
      box-shadow: none;
      width: calc(100% + 20px);
      font-size: 12px;
    }
    &:after {
      display: none !important;
    }
  }
.styled-radio--ou-donation.styled-radio {
  margin: 0 0 5px 0px;
  display: flex;
  flex-wrap: wrap;
  width: 100%;

  .radio-part {
    padding: 0px 5px;
    line-height: 1;
    @media (max-width: 720px) {
      width: 50%;
      margin-bottom: 10px;
    }
    @media (min-width: 720px) {
      min-width: 16.6666%;
      flex: 1;
      padding-right: 10px;
      padding-left: 0;
      max-width: 16.6666%;
      margin-bottom: 10px;

      &:nth-child(6n) {
        padding-right: 0;
      }
    }
  }
  input[type='radio'] {
    height: 0;
    top: 20px;
    position: relative;
    left: 20px;
    z-index: -1;
    visibility: hidden;
  }
  label {
    padding: 15px;
    background: #fff;
    border: 1px solid #ddd;
    font-weight: bold;
    color: rgb(87, 87, 87);
    width: 100%;
    text-align: center;
    border-radius: 4px;
    cursor: pointer;
    margin-top: -15px;
    display: block;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  input[type='radio']:checked + label {
    background: $color-blue;
    color: white;
  }
  label:hover {
    background: #e9f0f7;
  }
  .amount_other__wrapper {
    input[type='number'] {
      background: #fff;
      margin-top: -15px;
    }
  }
}
.control-label {
    padding-top: 3px;
    padding-bottom: 5px;
    display: block;
    font-size: 14px;
    color: #222;
}
.sponsorship-selector {
  max-width: 400px;
  margin-bottom: 20px;
      margin-top: 20px;
    padding-top: 20px;
}

select#sponsorSelect{
      border-radius: 4px;
    border: 1px solid #ddd;
    background-color: #f7f9fb;
    color: #222;
    cursor: pointer;
    width: 100%;
    outline: 0;
    box-sizing: border-box;
    min-width: 80px;
    transition: border-color .3s ease-in-out;
    font-size: 16px;
    align-items: center;
    box-shadow: none;
    display: inline-flex;
    height: 37px;
    justify-content: flex-start;
    padding: 0 10px;
    position: relative;
}
</style>
